import { XCircleIcon } from "@heroicons/react/outline";
import { isEmpty } from "lodash";

interface Props {
  fileName: string;
  discardFile: Function;
}
const FileCard = ({ fileName = "", discardFile }: Props) => {
  return (
    <div className="mx-auto mt-2 flex w-full rounded border border-solid px-2 py-1.5">
      <div className="text-sm font-light">{fileName}</div>
      <XCircleIcon
        className="my-auto ml-auto mr-1.5 h-4 w-4 cursor-pointer"
        onClick={() => discardFile()}
      />
    </div>
  );
};

export default FileCard;
